import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { InvoicePaymentStateEnumProvider, InvoiceDeliveryWarehouseStateEnumProvider } from "src/Sell/invoicesList/invoicesList-viewModel";
import { ServerSideDataLoader } from "uicomponents";
import { deliveryCartable, DeliveryCartablesListViewModel } from "./deliveryCartablesList-viewModel"

export class DeliveryCartablesListView extends View<DeliveryCartablesListViewModel>{
    GetViewUniqueId(): string {
        return "V-3A578D5D-D8D7-4AB8-9E7D-9D1B93553BB8"
    }
    loadHtml(): string {
        let element = require('./deliveryCartablesList.html').default;
        let style = require('./deliveryCartablesList.less');
        return element;
    }
    constructor() {
       super();
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set deliveryCartable(v: ObservableArray<deliveryCartable>) { this._deliveryCartable = v; } public get deliveryCartable(): ObservableArray<deliveryCartable> { return this._deliveryCartable;} private _deliveryCartable: ObservableArray<deliveryCartable>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set invoicePaymentStateEnumProvider(v: InvoicePaymentStateEnumProvider) { this._invoicePaymentStateEnumProvider = v; } public get invoicePaymentStateEnumProvider(): InvoicePaymentStateEnumProvider { return this._invoicePaymentStateEnumProvider;} private _invoicePaymentStateEnumProvider: InvoicePaymentStateEnumProvider;
    public set invoiceDeliveryWarehouseStateEnumProvider(v: InvoiceDeliveryWarehouseStateEnumProvider) { this._invoiceDeliveryWarehouseStateEnumProvider = v; } public get invoiceDeliveryWarehouseStateEnumProvider(): InvoiceDeliveryWarehouseStateEnumProvider { return this._invoiceDeliveryWarehouseStateEnumProvider;} private _invoiceDeliveryWarehouseStateEnumProvider: InvoiceDeliveryWarehouseStateEnumProvider;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
     
    refresh(){
        this.dataContext.refresh();
    }
}
